module.exports = __webpack_public_path__ + "static/media/5a271a88-c4b4-49a4-aa2a-f22923f9c754.b15dae44.jpeg";